import { IMobileWebViewParams } from 'apps/fleet-planner/types/mobileApp'

/**
 * Wrapper for `react-native-webview` function to post strings back to the mobile app.
 * @example `CARRIER_NOT_FOUND` or `SIGNED,123456`
 * @param mobileAppParam `BooleanParam` parsed by `use-query-params`
 * @param postMessage event name, all caps snake_case, ex: `RATE_SUBMITTED`
 * @param stringifiedData any data relevant to the current event
 */
export const postMessageToMobileApp = (
  mobileAppParam: IMobileWebViewParams['mobileApp'],
  postMessage: string,
  stringifiedData: string = ''
): void => {
  if (mobileAppParam) {
    const message = stringifiedData.length > 0 ? `${postMessage},${stringifiedData}` : postMessage
    ReactNativeWebView.postMessage(message)
  }
}
